var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "menu_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.333 15h13.334a.836.836 0 0 0 .833-.833.836.836 0 0 0-.833-.834H3.333a.836.836 0 0 0-.833.834c0 .458.375.833.833.833Zm0-4.167h13.334A.836.836 0 0 0 17.5 10a.836.836 0 0 0-.833-.833H3.333A.836.836 0 0 0 2.5 10c0 .458.375.833.833.833Zm-.833-5c0 .459.375.834.833.834h13.334a.836.836 0 0 0 .833-.834.836.836 0 0 0-.833-.833H3.333a.836.836 0 0 0-.833.833Z",
    fill: "currentColor"
  })));
};
export { SvgMenu as ReactComponent };